import { deskEyebrow, deskMuted, deskPrimaryBtn, deskSecondaryBtn, deskCard } from "./salesDeskStyles";
import type { SalesDeskLead } from "./salesDeskLead";

export function SalesDeskHome({
  onStart,
  onOrders,
  locationLabel,
  leads,
  leadsLoading,
}: {
  onStart: () => void;
  onOrders: () => void;
  locationLabel: string;
  leads: SalesDeskLead[];
  leadsLoading: boolean;
}) {
  const place = locationLabel ? locationLabel.toUpperCase() : "SALES DESK";

  return (
    <div>
      <p className={deskEyebrow}>{locationLabel ? `${place} · SALES DESK` : "SALES DESK"}</p>
      <h1 className="mt-2 text-[38px] font-semibold leading-[1.15] tracking-[-1.4px]">
        From the first hello
        <br />
        to their backyard.
      </h1>
      <p className={`mt-3 ${deskMuted}`}>The right building. A clear price. One next step.</p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <button type="button" onClick={onStart} className={`${deskPrimaryBtn} sm:min-w-[220px]`}>
          Start a sale →
        </button>
        <button type="button" onClick={onOrders} className={`${deskSecondaryBtn} sm:min-w-[220px]`}>
          Look up an order
        </button>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <section className={deskCard}>
          <h2 className="text-[21px] font-semibold tracking-[-0.4px]">Incoming leads</h2>
          {leadsLoading ? <p className={`mt-4 ${deskMuted}`}>Loading leads…</p> : null}
          {!leadsLoading && leads.length === 0 ? (
            <p className={`mt-4 ${deskMuted}`}>No leads yet. Start a sale when someone walks up.</p>
          ) : null}
          <div className="mt-2">
            {leads.map((lead) => (
              <div key={lead.id} className="flex items-center gap-3 border-b border-[#dce3dc] py-4 last:border-b-0 dark:border-zinc-700">
                <span className="grid h-[42px] w-[42px] shrink-0 place-items-center rounded-full bg-[#eef1e7] text-sm font-semibold dark:bg-zinc-800">
                  {lead.initials}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-semibold">{lead.name}</span>
                  <span className="block text-xs text-[#687772] dark:text-zinc-400">{lead.need}</span>
                </span>
                {lead.source ? (
                  <span className="rounded-full bg-[#e4edf2] px-2.5 py-1 text-[11px] text-[#315d75] dark:bg-zinc-800 dark:text-sky-200">
                    {lead.source}
                  </span>
                ) : null}
              </div>
            ))}
          </div>
        </section>
        <section className={deskCard}>
          <h2 className="text-[21px] font-semibold tracking-[-0.4px]">Buildings in progress</h2>
          <p className={`mt-4 ${deskMuted}`}>
            Builds you are waiting on will show here. The shop queue still lives in Legacy.
          </p>
          <button type="button" onClick={onOrders} className="mt-4 font-semibold text-[#164b43] dark:text-emerald-300">
            Look up orders →
          </button>
        </section>
      </div>
    </div>
  );
}
